import request from "src/utils/request";
import useApi from "../../utils/api/use-api";

const useInvitesApi = () => {
    return useApi(() => request("/api/invites/authoredInvites"));
};

export default useInvitesApi;
